import emailjs from "emailjs-com";

const SERVICE_ID = "mosano-ses";
const USER_ID = "user_xYVRZdMhAI6rqnPpzv3uE";

emailjs.init(USER_ID);

export const sendEmailWithForm = async (
  form: string | HTMLFormElement,
  TEMPLATE_ID: string
) => {
  await emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form);
};

export const sendEmailWithValues = async (
  values: Object,
  TEMPLATE_ID: string
) => {
  await emailjs.send(SERVICE_ID, TEMPLATE_ID, values);
};

export const fileToBase64 = (file: File): Promise<string | ArrayBuffer> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};
